export default "__VITE_ASSET__CSafvj6d__"